<template>
  <div id="ges-detail" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <header-v2 :title="'Sistema de vigilancia epidemiológico'" />
        <div class="row w-100 mt-5">
          <div class="col-md-12">
            <div style="display: flex; left: 15px; margin-bottom: 10px">
              <label class="mr-2 breadcrumb-link"
                ><button
                  class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                  style="
                    border: none;
                    background-color: transparent;
                    font-size: 16px;
                  "
                  @click.prevent="backGes"
                >
                  Volver
                </button></label
              >
            </div>

            <div>
              <h1>Examen Médico general de Planta</h1>
              <div class="row">
                <div class="col-12">
                  <b-overlay :show="loading" rounded="sm">
                    <template #overlay>
                      <OverlayButton clase="overlay-md"> </OverlayButton>
                    </template>
                    <FormExamen :record="formData" @onSuccess="onSuccess()" @onError="onError()" />
                  </b-overlay>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import { detailHealthCondition } from "@/services/health-tracker/saludCondition/service";
import FormExamen from "./components/forms/FormExamen.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import ModalSuccess from "../modals/ModalSuccess.vue";
import ModalError from "../modals/ModalError.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  components: {
    FormExamen,
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    MainBarMenuV2,
    HeadingUser,
    ModalSuccess,
    ModalError,
    OverlayButton,
  },
  data() {
    const me = this;
    return {
      type: me.$route.params.type,
      category: me.$route.params.category,
      id: me.$route.params.id,
      messageModal: "Examén guardado exitosamente",
      error: {
        message: "Error al guardar Formulario",
      },
      loading: false,
      formData: null,
    };
  },
  methods: {
    backGes() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: me.category,
          type: me.type,
        },
      });
    },
    onSuccess() {
      const me = this;
      me.$bvModal.show("modal-success");
      setTimeout(() => {
        me.backGes();
      }, 5000);
    },
    onError() {
      const me = this;
      me.$bvModal.show("modal-fail");
    },
    async loadDetail() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await detailHealthCondition(me.id);
        me.formData = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
  },
  mounted() {
    const me = this;
    if (me.id) me.loadDetail();
  },
};
</script>

<style lang="scss" scoped></style>
